window.addEventListener('DOMContentLoaded', function () {
  jQuery(function ($) {
    function playVideo() {
      $('.hero-video__video').get(0).play();
      $('.hero-video__thumbnail').toggleClass('hero-video__thumbnail--hidden');
    }

    // If the video exists on the page and it requested to autoplay, play it and hide the thumbnail
    if ($('.hero-video.hero-video__autoplay').length) {
      playVideo();
    }

    $('.hero-video__thumbnail').on('click', function (e) {
      $(this).toggleClass('hero-video__thumbnail--hidden');
      $(this).siblings('.hero-video__video').get(0).play();
    });
  });
});
